import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {componentFilter, dateFilter, optionFilter} from "../../../utils/filters";
import {postData} from "../../../utils/request";
import Button from "../../form/Button";
import Icon from "../../form/Icon";
import {ComponentFormatter, PidFormatter, remoteOptionFormatter, UnitFormatter} from "../../../utils/formatters";
import Select from "../../form/Select";

class StoreorderList extends React.Component {

    state = {
        send: false
    };

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, listFilter, selection, isLoading} = this.props;
        const props = {componentConfig, filter: listFilter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "storeorderList"}
                {...props}
                searchfield={true}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    ...(this.props.client === undefined && this.props.unknown === undefined ? {
                        "pid": {
                            header: 'Azonosító',
                            width: 1,
                            sortable,
                            filterable,
                            renderer: PidFormatter,
                        },
                    } : {}),
                    "fullnotenum": {
                        header: 'Szállítólevél szám',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "orderdate": {
                        header: 'Rendelés dátuma',
                        width: 2,
                        sortable,
                        filterable: dateFilter()
                    },
                    ...(this.props.client === undefined && this.props.unknown === undefined ? {
                        "client.partner.name": {
                            header: 'Partner',
                            width: 2,
                            sortable,
                            filterable
                        },
                        "client.destination.name": {
                            header: 'Hova',
                            width: 2,
                            sortable,
                            filterable
                        },
                    } : {}),
                    "store.name": {
                        header: 'Raktár',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "itemcount": {
                        header: 'Tételszám',
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, row.unit),
                        className: "unit"
                    },
                    "itemsum": {
                        header: 'Darabszám',
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value, row.unit),
                        className: "unit"
                    },
                    "state": {
                        header: 'Státusz',
                        width: 2,
                        sortable,
                        operator: '=',
                        filterable: optionFilter(this.props.config?.fielddefs?.state?.optionname ?? "storeorder_state"),
                        renderer: remoteOptionFormatter(this.props.config?.fielddefs?.state?.optionname ?? "storeorder_state")
                    },
                    ...(this.props.clientFields ? {
                        "client_component": {
                            header: 'Tevékenység',
                            width: 2,
                            sortable,
                            filterable: componentFilter({component: []}),
                            renderer: (value) => ComponentFormatter({component: value})

                        },
                        "client_component_id": {
                            header: 'Id',
                            width: 2,
                            sortable,
                            filterable
                        },
                    } : {
                        "ordertype": {
                            header: 'Típus',
                            width: 1,
                            sortable,
                            operator: "=",
                            filterable: <Select
                                storeType="local"
                                options={[
                                    {key: "0", label: "Kiszedés"},
                                    {key: "1", label: "Bevételezés"}
                                ]}
                                label={false}
                                objectValue={false}
                                isClearable={true}
                                valueKey="key"
                                labelKey="label"
                            />,
                            renderer: (value) => ({"0": "Kiszedés","1": "Bevételezés"})[value]
                        },
                    }),
                    ...(this.props.claim ? {
                        "ordertype": {
                            header: 'Típus',
                            width: 1,
                            sortable,
                            operator: "=",
                            filterable: <Select
                                storeType="local"
                                options={[
                                    {key: "0", label: "Kiszedés"},
                                    {key: "1", label: "Bevételezés"}
                                ]}
                                label={false}
                                objectValue={false}
                                isClearable={true}
                                valueKey="key"
                                labelKey="label"
                            />,
                            renderer: (value) => ({"0": "Kiszedés","1": "Bevételezés"})[value]
                        },
                    } : {}),
                    "actions": {
                        header: <Icon lib="fa" name="print"/>,
                        width: 1,
                        renderer: (value, rowData) =>
                            <Button
                                type="button"
                                block={true}
                                color="default"
                                size="xs"
                                tooltip="Dokumentumok újraküldése a raktárnak"
                                icon={{lib: "fas", name: this.state.send ? "sync-alt" : "share", spin: this.state.send}}
                                disabled={isLoading || this.state.send}
                                onClick={(e) => {
                                    e && e.stopPropagation();
                                    e && e.preventDefault();
                                    this.setState({send: true}, async () => {
                                        try {
                                            await this.props.processAction(async () => {
                                                await postData({
                                                    action: componentConfig.componentname + '.requestDocuments',
                                                    data: rowData
                                                });
                                                return false;
                                            });
                                        } catch (e) {

                                        }
                                        this.setState({send: false});
                                    });
                                    return false;
                                }}
                            >

                            </Button>
                    },
                    /*"correctional": {
                        header: "Korrekciós",
                        width: 1,
                        operator: "=",
                        filterable: optionFilter("storeorder_correction"),
                        renderer: remoteOptionFormatter("storeorder_correction")
                    },*/
                }}
                rowClassName={(rowData) => {
                    if (this.props.stateTypes.Revision(rowData.state)) {
                        return {"danger": true};
                    } else if (this.props.stateTypes.Completed(rowData.state)) {
                        return {"success": true};
                    } else if (this.props.stateTypes.Reserved(rowData.state) || this.props.stateTypes.Modification(rowData.state)) {
                        return {"warning": true};
                    } else if (this.props.stateTypes.Completed(rowData.state, ">")) {
                        return {"deleted": true};
                    }
                    if (this.props.stateTypes.Settled(rowData.state)) {
                        if (rowData.ordertype + "" === "1") {
                            return {"danger": true};
                        } else {
                            return {"success": true};
                        }
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default StoreorderList;
